import * as React from "react"
const IconGearError = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 21}
        height={props.height ?? 21}
        viewBox="0 0 21 21"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke ?? "#94A3B8"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth ?? 1.5}
            d="M11.425 17.433c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37 1 .608 2.296.07 2.572-1.065.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.66 1.66 0 0 0-.324.114m2.641 8.211-5-5m0 5 5-5m-13-5a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z"
        />
    </svg>
)
export default IconGearError
